import { type Movie, type Tv } from '@tmdb-graphql-api/schema/types';
import { getMovieCertFromReleaseDates } from '#helpers/getMovieCertFromReleaseDates.ts';
import { getTvCertFromContentRatings } from '#helpers/getTvCertFromContentRatings.ts';

export type MovieCertificationData = {
  movie: Pick<Movie, 'releaseDates'>;
};

export type TvCertificationData = {
  tv: Pick<Tv, 'contentRatings'>;
};

export const formatCertifications = (
  data: MovieCertificationData | TvCertificationData | null | undefined,
  country: string,
) => {
  if (!data) {
    return;
  }

  if ('movie' in data) {
    return getMovieCertFromReleaseDates(data.movie.releaseDates ?? [], country);
  }

  if ('tv' in data) {
    return getTvCertFromContentRatings(data.tv.contentRatings ?? [], country);
  }

  return;
};
